import { Link } from "react-router-dom";
import { Radar, Plane, Crosshair, Target, Shield, ArrowUpRight } from "lucide-react";
import "./Defence.css";
import DefenceImg from '../ui/defence.svg';
import DroneImg from '../ui/dronebig.svg'


const MODULES = [
    {
        icon: Radar,
        title: "Radar & Missile Training",
        desc: "High-fidelity simulators for SAM, AAA, and radar operations with instructor-led, scenario-based mission training.",
    },
    {
        icon: Plane,
        title: "Drone Piloting",
        desc: "Advanced BVLOS, FPV, and tactical UAV simulators featuring realistic terrain, sensor integration, and mission-based training.",
    },
    {
        icon: Crosshair,
        title: "Tank Simulators",
        desc: "Comprehensive armoured fighting vehicle simulators for driver, gunner, commander, and loader training.",
    },
    {
        icon: Target,
        title: "Virtual Parachute Jumps",
        desc: "Realistic HALO, HAHO, and static-line parachute training with simulated weather, wind conditions, and equipment behaviour.",
    },
    {
        icon: Shield,
        title: "CQB & Squad VR",
        desc: "Immersive close-quarters battle training with multi-user collaboration, Rules of Engagement (ROE) scenarios, and After Action Review (AAR) analytics.",
    },
];


const DEF_BG = DefenceImg;
const DRONE_BG = DroneImg;



export const Defence = () => {

    return (
        <section
            id="defence"
            data-testid="defence-section"
            className="defence-section position-relative"
        >
            <div className="container-db">
                <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-4 mb-5 pb-3">
                    <div>

                        <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                            ⟶  Make in India · Proudly Indigenous
                        </div>

                        <h2 className="font-heading defence-title">
                            Defence - grade
                            <br />
                            Simulations
                        </h2>
                    </div>
                    <p className="defence-desc mb-0" style={{ fontSize: '18px' }}>
                        We engineer mission-critical simulation systems that combine immersive technologies with high-fidelity environments to deliver realistic, safe, and effective training for defence and strategic operations.
                    </p>
                </div>

                {/* Hero split */}
                <div className="row g-3 mb-5">
                    <div className="col-12 col-md-6">
                        <div
                            className="position-relative defence-hero-img overflow-hidden"
                            data-testid="defence-hero-image"
                        >
                            <div
                                className="defence-bg-img"
                                style={{ backgroundImage: `url(${DEF_BG})` }}
                            />

                            <div className="defence-label-bottom">
                                <div className="font-heading defence-hero-subtitle" style={{ color: "#40e0d0" }}>
                                    VR Tactical Trainer · LIVE
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="position-relative defence-hero-img overflow-hidden">
                            <div
                                className="defence-bg-img"
                                style={{ backgroundImage: `url(${DRONE_BG})` }}
                            />

                            <div className="defence-label-bottom">
                                {/* <div className="font-mono-tech defence-module-text mb-2">
                                    Module · 02
                                </div> */}
                                <h3 className="font-heading defence-hero-subtitle m-0" style={{ color: "#40e0d0" }}>
                                    Drone Ops
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modules grid */}
                <div className="defence-modules-wrapper">
                    <div className="row g-0">
                        {MODULES.map((m) => {
                            const Icon = m.icon;
                            return (
                                <div
                                    key={m.title}
                                    data-testid={`defence-module-${m.title.replace(/\s+/g, "-").toLowerCase()}`}
                                    className="col-12 col-md-6 col-lg-2 flex-grow-1 defence-module-card"
                                >
                                    <Icon size={24} className="defence-module-icon mb-4" />
                                    <p className="font-heading defence-module-title">
                                        {m.title}
                                    </p>

                                    <p className="defence-module-desc m-0">{m.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="mt-5 pt-3 d-flex flex-wrap gap-3">
                    <Link
                        to="/defence"
                        data-testid="defence-explore-cta"
                        className="hero-btn-primary font-mono-tech text-decoration-none text-dark fw-bold"
                    >
                        Explore Defence Capabilities  <ArrowUpRight size={16} />
                    </Link>
                    <Link
                        to="/contact?interest=Defence"
                        data-testid="defence-rfp-cta"
                        className="hero-btn-secondary font-mono-tech text-decoration-none"
                    >
                        Discuss Your Requirements
                    </Link>
                </div>
            </div>
        </section>
    );
};


export default Defence;
